import logo from './logo.png';
import arrowRight from './arrowRight.png';
import arrowBottom from './arrowBottom.png';
import addIcon from './addIcon.png';
import success from './success.png';
import emptyHistory from './emptyHistory.png';
import service from './service.png';
import rocket from './rocket.png';
import moreFeedbackBg from './moreFeedbackBg.png';
import next from './next.png';
import back from './back.png';
import tick from './tick.png';
import iconImage from './iconImage.png';
import picVideo from './picVideo.png';
import iconClose from './icon/close.png';
import play from './play.png';
import iconError from './icon/iconError.png';
import iconCorrect from './icon/iconCorrect.png';

export default {
  logo,
  arrowRight,
  arrowBottom,
  addIcon,
  success,
  emptyHistory,
  service,
  rocket,
  moreFeedbackBg,
  next,
  back,
  tick,
  iconImage,
  picVideo,
  iconClose,
  play,
  iconError,
  iconCorrect,
};
